<template>
    <CModal :visible="visible" alignment="center" scrollable size="xl" @close="$emit('close')">
        <CModalHeader>
            <CModalTitle>Pending Reviews ({{ downtimeEvents.length }})</CModalTitle>
        </CModalHeader>
        <CModalBody>
            <div v-if="loadingIncidents" class="py-4 text-center">
                <CSpinner />
            </div>
            <div v-else-if="downtimeEvents.length === 0" class="py-4 text-center text-muted">No pending items to review.</div>
            <div v-else class="d-flex flex-column gap-4">
                <DowntimeEventCard v-for="event in downtimeEvents" :key="event.id" :downtime-event="event" @reviewed="onReviewed" />
            </div>
        </CModalBody>
        <CModalFooter>
            <CButton color="secondary" @click="$emit('close')">Close</CButton>
        </CModalFooter>
    </CModal>
</template>

<script setup>
import { ref, watch } from 'vue';
import { CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CButton, CSpinner } from '@coreui/vue';
import DowntimeEventCard from './DowntimeEventCard.vue';
import { $http } from '@/bootstrap.js';
import { buildUrlWithQuery } from '@/Utils/buildUrlWithQuery';

const props = defineProps({
    visible: { type: Boolean, default: false },
    unitIdentifier: { type: String, default: '' },
    month: { type: String, default: '' },
});

const emit = defineEmits(['close', 'updated']);

const loadingIncidents = ref(false);
const downtimeEvents = ref([]);

async function fetchPendingEvents() {
    if (!props.unitIdentifier || !props.month) return;

    loadingIncidents.value = true;
    try {
        const url = buildUrlWithQuery(route('eds-operations.pending-downtime-events'), {
            unit_identifier: props.unitIdentifier,
            month: props.month,
            limit: 200,
        });
        const response = await $http.get(url);
        downtimeEvents.value = response.data;
    } catch (error) {
        console.error('Error fetching pending events:', error);
    } finally {
        loadingIncidents.value = false;
    }
}

function onReviewed(eventId) {
    downtimeEvents.value = downtimeEvents.value.filter((e) => e.id !== eventId);
    emit('updated');
}

watch(
    () => props.visible,
    (val) => {
        if (val) {
            fetchPendingEvents();
        }
    },
);
</script>
